import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLazySelector } from 'hooks'
import { MaintenanceStatus } from 'core/system/types'
import { MaintenanceNotifications } from 'modules/Notifications/components'
import { setMaintenanceViewedState } from 'modules/Notifications/slices/notifications'
import { MaintenanceNotificationsUtils } from 'modules/Notifications/utils'

const MaintenanceNotificationsContainer: React.FC = () => {
  const dispatch = useDispatch()
  const { maintenanceInformation, maintenanceViewed } = useLazySelector(
    ({ notifications, system }) => {
      const { maintenanceViewed } = notifications
      const maintenanceInformation =
        system.customerInformation?.result?.information?.maintenanceInformation
      return {
        maintenanceInformation,
        maintenanceViewed,
      }
    }
  )

  const storageMaintenanceNotificationsViewed =
    MaintenanceNotificationsUtils.getMaintenanceNotificationsState() ===
    MaintenanceNotificationsUtils.viewed

  const maintenanceNotificationsViewed = maintenanceViewed || storageMaintenanceNotificationsViewed

  useEffect(() => {
    dispatch(setMaintenanceViewedState(maintenanceNotificationsViewed))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  function handleClose() {
    MaintenanceNotificationsUtils.markMaintenanceNotificationsViewed()
    dispatch(setMaintenanceViewedState(true))
  }

  const { maintenanceStatus, enablePreMaintenance } = maintenanceInformation || {}
  // TODO: check with real API
  const isShowNotification =
    maintenanceStatus === MaintenanceStatus.Planned &&
    !!enablePreMaintenance &&
    // Strict comparison is used because to prevent blink on page refresh
    // Redax storage is initialized with `null`
    maintenanceViewed === false

  return (
    <MaintenanceNotifications
      notification={maintenanceInformation}
      isShow={isShowNotification}
      onClose={handleClose}
    />
  )
}

export default MaintenanceNotificationsContainer
